import { render, staticRenderFns } from "./PosQualifierEditor.vue?vue&type=template&id=a2f6cd5a&scoped=true"
import script from "./PosQualifierEditor.vue?vue&type=script&lang=ts"
export * from "./PosQualifierEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f6cd5a",
  null
  
)

export default component.exports